import type { Entity } from '@models/Entity'

import { request } from '../../../gateways/api'
import type { SubprocesTemplate } from '../types/SubprocesTemplate'

export const fetchSubprocesTemplatesForEntity = async (entity: Entity) => {
  const result = await request<SubprocesTemplate[]>({
    url: `/rest/${entity.type}/${entity.id}/subprocestemplate`,
    method: 'GET',
  })

  return result
}
